//import action types
import service from "../service.js";
import * as types from "./types";

const loginSuccess = (user) => ({
    type: types.login_success,
    payload: user
})

const loginFailure = (error) => ({
    type: types.login_failure,
    payload: error
})

const signupSuccess = (user) => ({
    type: types.signup_success,
    payload: user
})

const name_search = res => ({
    type: types.nameSearch,
    payload: res
    
})

const email_search = res => ({
    type: types.emailSearch,
    payload: res
})

const skills_search = res => ({
    type: types.skillsSearch,
    payload: res
})

const gaperid_search = res => ({
    type: types.gaperIdSearch,
    payload: res
})

const location_search = res => ({
    type: types.locationSearch,
    payload: res
})

const top_profiles = res => ({
    type: types.skillsSearch,
    payload: res
})

const client_notifications = res => ({
    type: types.client_notifications,
    payload: res
})

const get_client_profiles_details = res => ({
    type: types.get_client_profiles_details,
    payload: res
})

const get_client = res => ({
    type: types.get_client,
    payload: res
})

const get_public_client = res => ({
    type: types.get_public_clients,
    payload: res
})

const update_client_Profiles = res => ({
    type: types.update_client_profiles,
    payload: res
})

const fetchedClientBoards = (data) => ({
    type: types.GET_ALL_CLIENT_BOARDS,
    payload: data
})

//This method have login user functionality
export const loginUser = ((email, password) => async (dispatch) => {

    return await service.getUser(email, password)
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(loginSuccess(response.user))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })

})

export const signupUser = ((email, password) => async (dispatch) => {

    return await service.addNewUser(email, password)
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(signupSuccess(response.user))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })

})

export const nameSearch = ( (data) => async(dispatch) => {
    return await service.nameSearch(data)
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(name_search(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })
})
export const emailSearch = ((data) => async(dispatch) => {
    return await service.emailSearch(data)
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(email_search(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })
})
export const secondarySkillsSearch= ((data) => async(dispatch) => {
    return await service.secondarySkillsSearch(data)
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(skills_search(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })
})
export const primarySkillsSearch= ((data) => async(dispatch) => {
    return await service.primarySkillsSearch(data)
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(skills_search(response.data))
        return Promise.resolve(response.data);
    }).catch(() => {
        return Promise.reject();
    })
})
export const indexSearch= ((data) => async(dispatch) => {
    return await service.indexSearch(data)
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(skills_search(response.data))
        return Promise.resolve(response.data);
    }).catch(() => {
        return Promise.reject();
    })
})
export const gaperIdSearch= ((data) => async(dispatch) => {
    return await service.gaperIdSearch(data)
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(gaperid_search(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })
})
export const locationSearch= ((data) => async(dispatch) => {
    return await service.locationSearch(data)
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(location_search(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })
})

export const topFiveProfiles= (() => async(dispatch) => {
    return await service.topFiveProfiles()
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(top_profiles(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })
})

export const getClient = ( (boardId, url_with_token) => async(dispatch) => {
    return await service.getClient(boardId, url_with_token)
    .then((response) => {
        if(response.error){
            throw response.error
        }
        dispatch(get_client(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })
})

export const getPublicClient = ( (boardId) => async(dispatch) => {
    return await service.getPublicClient(boardId)
    .then((response) => {
        if(response.error){
            throw response.error
        }
        dispatch(get_public_client(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })
})

export const getClientNotification = ( (client_invitation_id) => async(dispatch) => {
    return await service.getClientNotification(client_invitation_id)
    .then((response) => {
        if(response.error){
            throw response.error
        }
        dispatch(client_notifications(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })
})

export const getClientProfilesDetails = ( (ids) => async(dispatch) => {
    return await service.getClientProfilesDetails(ids)
    .then((response) => {
        if(response.error){
            throw response.error
        }
        dispatch(get_client_profiles_details(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })
})

export const updateClientProfiles = ( (profiles, client_invitation_id) => async(dispatch) => {
    return await service.updateClientProfiles(profiles, client_invitation_id)
    .then((response) => {
        if(response.error){
            throw response.error
        }
        dispatch(update_client_Profiles(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })
})


export const getClientAllBoards = ((dashboardId) => async (dispatch) => {

    return await service.getClientAllBoards(dashboardId)
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(fetchedClientBoards(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })

})